import React from 'react';
import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import Selector from './molecules/selector';
import { DropdownSearchInput } from 'molecules';
import Property from './molecules/property';
import { FlexBetweenWrapper, ScrollableDropdownBodyWrapper, DropdownContentWrapper, StaticWrapper } from 'wrappers';
import internalState from './internalState';
import {escapedRegex} from 'utils'

const containerRef = React.createRef();
const headerRef = React.createRef();

export const definition = {
  name: "PropertySelector",
  controller: Controller,
  initialProps: ({ properties, selectedPropertyId, scrollLeft }) => ({ properties, selectedPropertyId, left: (headerRef?.current?.offsetLeft ?? 0) - (scrollLeft ?? 0) }),
  props: internalState,
  elements: [
    {
      wrapper: FlexBetweenWrapper,
      name: 'HeaderWrapper',
      ref: headerRef,
      elements: [
        {
          component: Selector,
          name: 'Selector',
          bindings: ({ selectedPropertyId, properties, isOpen }) => {
            const selectedProperty = properties?.find?.(p => p.id == selectedPropertyId)
            return { isOpen, selectedProperty, containerRef }
          },
          displayState: ({ isOpen }) => ({ isOpen })
        },
      ]
    },
    {
      wrapper: ScrollableDropdownBodyWrapper,
      name: 'Body',
      ref: containerRef,
      renderIf: ({ isOpen }) => isOpen,
      displayState: ({ left }) => ({ left }),
      elements: [
        {
          component: DropdownSearchInput,
          name: 'Search',
          bindings: ({ searchTerm }) => ({ value: searchTerm, placeholder: "Search" })
        },
        {
          wrapper: DropdownContentWrapper,
          name: 'Properties',
          elements: [
            {
              component: Property,
              name: 'Property',
              isListOf: 'properties',
              renderIf: ({ property, searchTerm }) => (new RegExp(escapedRegex(searchTerm, 'i'))).test(property.name),
              bindings: ({ property }) => ({ icon: property.icon, propertyName: property.name, id: property.id })
            }
          ]
        }
      ]
    }
  ]
}

const PropertySelector = ContainerComponent(definition)

export default wrap(PropertySelector, StaticWrapper)
